import useUser from '@vl-core/hooks/useUser';

export function useIsReferrer() {
  const user = useUser();
  const userType = user?.user_type_code;

  return userType === 'REFERRER';
}

export default useIsReferrer;
